<template>
  <div class="legal py-20">
    <div class="max-w-4xl mx-auto px-4">
      <div class="grid grid-cols-12 gap-2 justify-center">
        <BaseCard v-for="(item, index) in legal" :key="`legal-${index}`" :full-bleed="true"
          class="cursor-pointer col-span-12 sm:col-span-6 lg:col-span-3 transition-shadow shadow hover:shadow-lg"
          @click="handleItem(item.slug)">
          <div class="p-6">
            <img :src="item.image" alt="shield_icon" class="mx-auto mb-4" />
            <TypeHeading :variant="$options.Typography.Heading.HEADLINE" :weight="$options.Typography.Weights.REGULAR"
              tag="p" class="text-center">
              {{ item.type }}
            </TypeHeading>
          </div>
        </BaseCard>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseCard, TypeHeading, constants } from '@bambeehr/pollen';
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import useGlobalSettings from '@/hooks/useGlobalSettings';
const { Typography } = constants;
import { RouteBase, Slugs } from '@/modules/InformationPages/Legal/constants/Routes'

export default defineComponent({
  name: 'LegalRoot',
  Typography,
  components: { BaseCard, TypeHeading },
  setup() {
    const { setHeader } = useGlobalSettings();

    setHeader({
      header: `Legal Documents, Terms and Conditions`,
      subheader: null,
      heroImage: null,
      metaTitle: `Legal Documents, Terms and Conditions`,
      registration: false,
      noHero: false,
    });

    useMeta(() => ({ title: `Legal Documents` }));
  },
  data() {
    return {
      legal: [
        {
          type: 'Terms Of Service',
          slug: Slugs.TOS,
          image: '/assets/information/legal/green-shield.svg',
        },
        {
          type: 'Privacy',
          slug: Slugs.PRIVACY,
          image: '/assets/information/legal/green-shield.svg',
        },
        {
          type: 'HIPAA',
          slug: Slugs.HIPAA,
          image: '/assets/information/legal/green-shield.svg',
        },
        {
          type: 'Retention',
          slug: Slugs.DATA_RETENTION,
          image: '/assets/information/legal/green-shield.svg',
        },
        {
          type: 'Cookie Policy',
          slug: Slugs.COOKIE,
          image: '/assets/information/legal/green-shield.svg',
        },
        {
          type: 'Payroll',
          slug: Slugs.PAYROLL,
          image: '/assets/information/legal/green-shield.svg',
        },
      ],
    };
  },
  head() { },
  methods: {
    handleItem(slug) {
      return this.$router.push(`/${RouteBase}/${slug}`);
    },
  },
});
</script>

<style scoped>
.legal {
  min-height: calc(100vh - 775px);
}
</style>
